import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ArrowLeft = createIcon({
  displayName: 'ArrowLeft',
  viewBox: '0 0 24 24',
  path: /*#__PURE__*/_jsx("path", {
    d: "M15 5L8 11.9815L15 19",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.9",
    strokeLinecap: "round"
  })
});
//# sourceMappingURL=ArrowLeft.js.map